import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

class StepIndicator extends React.Component {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    numSteps:    PropTypes.number.isRequired
  }

  render() {
    return (
      <div className='form__step-indicator'>
        <ul className='step-indicator'>
          { this._renderSteps() }
        </ul>
      </div>
    );
  }

  // private

  _renderSteps() {
    const steps = [];

    for (let i = 0; i < this.props.numSteps; i++) {
      const stepNum = i + 1;

      steps.push(
        <li className={ classNames('step-indicator__step', { 'step-indicator__step--active': stepNum <= this.props.currentStep }) }
          key={ i } />
      );
    }

    return steps;
  }
}

export default StepIndicator;



// WEBPACK FOOTER //
// ./app/components/shared/form/_StepIndicator.jsx